import Vue from 'vue'
import Vuex from 'vuex'
import request from '@/utils/request'
import {
  getEdcShopGoodsCategorys,
} from "@/api/index";

Vue.use(Vuex)
!!~location.href.indexOf('zbdian.cn')
  ? (document.title = '专帮店后台')
  : (document.title = '智慧SaaS商户管理后台')
export default new Vuex.Store({
  state: {
    shopInfo: {
      businessHours: '00:00-23:00', //"00:00-23:00",
      businessLicenceImage: '', //营业执照照片
      distributionPrice: 0, //配送费
      edcfuncTags: '1', //1店家配送2到店吃 逗号分隔
      industryLicenseImage: '', // 行业许可证
      isBusiness: 1, //当前是否营业 1是 0否
      isVerified: 1, // 1已认证 0未认证
      latitude: 1, //纬度 - 高德地图
      longitude: 1, //经度- 高德地图
      monthlySales: 1, //月售
      sendScope: 1, //配送范围（单位：公里）
      shopAddress: '', //地址
      shopFaceImage: '', //门脸照片
      shopImages: '', //店铺多图 逗号分隔
      shopLogo: '', //店铺LOGO
      shopName: '', //店铺名称
      shopScore: 1, //店铺评分  0 - 5
      shopTel: '', //电话  如果多个,使用 | 分开
      toSendPrice: 0, //起送价
      bannerImage: '', //店铺首页的头部背景图

      indexBackgroundImage: '', // 小程序 进入店铺页前的页面-形象页（背景图）
      needChoosePeopleNum: 1, //设置扫码点餐-点餐前是否需要人数填写
      payMethod: 1, //支付方式  0 线下--前台支付 1  线上

      specTags: '', //特色标签
      shopCategoryId: 0, //二级分类ID
      shopCategoryIdTags: '', //分类标签 （一级分类ID,二级分类ID）
      shopId: '', //店铺id
      shoperUserId: 0, //商户用户ID
      completeNum: 0, //资料完成数量  9以下 一般  9、10 优秀
      edcShopQRcode: '', //店铺二维码值

      isAutoClearTable: 1, //是否自动清桌
      printTempType: 1 //打印模板类型 1.按顺序显示 2.按商品分类显示
    },
    productsList: [
      {
        title: '店铺拓展',
        list: [
          {
            img: `${request.baseUrl}/images/edcmanage/easyBack/func-type1.png`,
            name: '外卖功能',
            content: '实现回头客营销',
            userFuncType: 1
          },
          {
            img: `${request.baseUrl}/images/edcmanage/easyBack/func-type2.png`,
            name: '扫码点餐',
            content: '降低人工成本',
            userFuncType: 2
          },
          {
            img: `${request.baseUrl}/images/edcmanage/easyBack/func-type3.png`,
            name: '套餐开通',
            content: '外卖+点餐双管齐下',
            userFuncType: 3
          },
          {
            img: require('@/assets/img/marketing/func-type4.png'),
            name: '智慧数字经营小程序',
            content: '智慧数字经营',
            userFuncType: 4
          },
        ]
      },
      {
        title: '营销应用',
        list: [
          {
            img: `${request.baseUrl}/images/edcmanage/easyBack/groom-list-img1.png`,
            name: '网付合作商',
            content: '支付+营销+营运',
            linkurl: 'https://www.163.gg/'
          },
          {
            img: `${request.baseUrl}/images/edcmanage/easyBack/groom-list-img2.png`,
            name: '易城市',
            content: '打造更省钱、又赚钱的营销型平台',
            linkurl: 'https://www.yichengshi.cn/'
          }
        ]
      }
    ],
    messageList: [],
    projectConfig: {
      logo: !!~location.href.indexOf('zbdian.cn')
        ? require('@/assets/img/login/zbd-logo.png')
        : !!~location.href.indexOf('wei.gg') ?
          require('@/assets/img/login/logo.png')
          : require('@/assets/img/login/sys-logo.png'),
      leftBg: !!~location.href.indexOf('zbdian.cn')
        ? require('@/assets/img/login/zbd-left-bg.png')
        : require('@/assets/img/login/left-bg.png'),
      bottomTips1: !!~location.href.indexOf('zbdian.cn')
        ? '温州专帮信息科技有限公司版权所有，并保留所有权利'
        : '《中华人民共和国增值电信业务经营许可证》',
      bottomTips2: !!~location.href.indexOf('zbdian.cn')
        ? '浙ICP备16020428号-9'
        : '浙B2-20171112号 码点餐 ©2016-2018 Madiancan.com温州专帮信息科技有限公司 版权所有',
      appName: !!~location.href.indexOf('zbdian.cn') ? '专帮小程序' : '系统'
    },
    applitInfo: null,
    appltType: 'wx',
    shopStoreId: "",
    isOwn: !!~location.href.indexOf('wei.gg') || !!~location.href.indexOf('madiancan.com') || !!~location.href.indexOf('192.168')|| !!~location.href.indexOf('api.yichengshi.cn'),
    oemInfo: null,
    oemInstitution:null,
    userFuncInfo: null,
    goodsCategorys: [],
    decorationShopType: 1,
  },
  mutations: {
    setShopStoreId(state, shopStoreId) {
      state.shopStoreId = shopStoreId
      localStorage.shopStoreId = shopStoreId
    },
    setShopInfo(state, shopInfo) {
      state.shopInfo = Object.assign(state.shopInfo, shopInfo)
      localStorage.setItem('shopInfo', JSON.stringify(state.shopInfo))
      localStorage.shopId = shopInfo.shopId
      if (!localStorage.shopStoreId) {
        localStorage.shopStoreId = shopInfo.shopStoreId
      }
    },
    clearShopInfo(state) {
      state.shopInfo = {
        businessHours: '00:00-23:00', //"00:00-23:00",
        businessLicenceImage: '', //营业执照照片
        distributionPrice: 11, //配送费
        edcfuncTags: '1', //1店家配送2到店吃 逗号分隔
        industryLicenseImage: '', // 行业许可证
        isBusiness: 1, //当前是否营业 1是 0否
        isVerified: 1, // 1已认证 0未认证
        latitude: 1, //纬度 - 高德地图
        longitude: 1, //经度- 高德地图
        monthlySales: 1, //月售
        sendScope: 1, //配送范围（单位：公里）
        shopAddress: '地址', //地址
        shopFaceImage: '', //门脸照片
        shopImages: '', //店铺多图 逗号分隔
        shopLogo: '', //店铺LOGO
        shopName: '店铺名称', //店铺名称
        shopScore: 1, //店铺评分  0 - 5
        shopTel: '', //电话  如果多个,使用 | 分开
        toSendPrice: 0, //起送价
        bannerImage: '', //店铺首页的头部背景图

        indexBackgroundImage: '', // 小程序 进入店铺页前的页面-形象页（背景图）
        needChoosePeopleNum: 1, //设置扫码点餐-点餐前是否需要人数填写
        payMethod: 1, //支付方式  0 线下--前台支付 1  线上

        specTags: '', //特色标签
        shopCategoryId: 11, //二级分类ID
        shopCategoryIdTags: '', //分类标签 （一级分类ID,二级分类ID）
        shopId: '', //店铺id
        shoperUserId: 0, //商户用户ID
        completeNum: 0, //资料完成数量  9以下 一般  9、10 优秀
        edcShopQRcode: '111', //店铺二维码值

        isAutoClearTable: 1, //是否自动清桌
        printTempType: 1 //打印模板类型 1.按顺序显示 2.按商品分类显示
      }
    },
    setMessage(state, messageList) {
      state.messageList = messageList
    },
    setAppltInfo(state, applitInfo) {
      state.applitInfo = applitInfo
    },
    setAppltType(state, appltType) {
      state.appltType = appltType
    },
    setOemInfo(state, oemInfo) {
      state.oemInfo = oemInfo
    },
    setOemInstitution(state, oemInstitution) {
      state.oemInstitution = oemInstitution
    },
    setUserFuncInfo(state, userFuncInfo) {
      state.userFuncInfo = userFuncInfo
    },
    setGoodsCategorys(state, goodsCategorys) {
      state.goodsCategorys = goodsCategorys;
    },
    setDecorationShopType(state, decorationShopType) {
      state.decorationShopType = decorationShopType;
    },
  },
  actions: {
    updateGoodsCategorys({ commit, state }) {
      let categoryNatureType = 1;
      if (state.decorationShopType == 4) {
        categoryNatureType = 2;
      }
      getEdcShopGoodsCategorys({
        categoryNatureType,
        pageNo: 1,
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          commit('setGoodsCategorys', res.data);
        }
      });
    },
    updateDecorationShopType({ commit, dispatch }, decorationShopType) {
      commit('setDecorationShopType', decorationShopType);
      dispatch('updateGoodsCategorys');
    },
    updateShopInfo({ commit }, shopInfo) {
      commit('setShopInfo', shopInfo)
    },
    clearShopInfo({ commit }) {
      commit('clearShopInfo')
    },
    updateMessage({ commit }, messageList) {
      commit('setMessage', messageList)
    },
    updateAppltInfo({ commit }, applitInfo) {
      commit('setAppltInfo', applitInfo)
    },
    changeAppltType({ commit }, appltType) {
      commit('setAppltType', appltType)
    },
    updateShopStoreId({ commit }, shopStoreId) {
      commit('setShopStoreId', shopStoreId)
    },
    updateOemInfo({ commit }, oemInfo) {
      console.log(oemInfo)
      commit('setOemInfo', oemInfo)
    },
    updateOemInstitution({ commit }, oemInstitution) {
      console.log(oemInstitution)
      commit('setOemInstitution', oemInstitution)
    },
    updateUserFuncInfo({ commit }, userFuncInfo) {
      console.log(userFuncInfo)
      commit('setUserFuncInfo', userFuncInfo)
    },
  }
})
